import { differenceInCalendarDays } from 'date-fns';

export function parseApiTimestamp(value) {
  if (!value) return null;
  if (value instanceof Date) return Number.isNaN(value.getTime()) ? null : value;
  const raw = String(value).trim();
  if (!raw) return null;
  const hasTimezone = /([zZ]|[+-]\d{2}:\d{2})$/.test(raw);
  const normalized = hasTimezone ? raw : `${raw}Z`;
  const date = new Date(normalized);
  return Number.isNaN(date.getTime()) ? null : date;
}

export function formatRelativeNotificationTime(value, now = new Date()) {
  const createdAt = parseApiTimestamp(value);
  if (!createdAt) return 'Just now';

  const diffMs = now.getTime() - createdAt.getTime();
  if (diffMs < 60 * 1000) return 'Just now';

  const minutes = Math.floor(diffMs / (60 * 1000));
  if (minutes < 60) return `${minutes} minute${minutes === 1 ? '' : 's'} ago`;

  const hours = Math.floor(diffMs / (60 * 60 * 1000));
  if (hours < 24) return `${hours} hour${hours === 1 ? '' : 's'} ago`;

  const dayDiff = differenceInCalendarDays(now, createdAt);
  if (dayDiff === 1) return 'Yesterday';
  return `${dayDiff} day${dayDiff === 1 ? '' : 's'} ago`;
}

